import {css} from "@panda/css";

import {Select} from "@pg-design/select-module";
import {form, FormFieldType, IFormProps} from "@pg-mono/form";

import {PromotionType, promotionTypes} from "../../../helpers/PromotionType";
import {PromotionListSearchFilter} from "./PromotionListSearchFilter";

export const promotionListFilterFields = {
    type: FormFieldType.Select
};

export interface IPromotionListFilterFields {
    type: PromotionType;
}

interface IPromotionListFilters extends IFormProps<IPromotionListFilterFields> {}

const PromotionListFiltersC = (props: IPromotionListFilters) => {
    const typeSelectProps = props.getFieldProps("type");
    const currentTypeOption = promotionTypes.filter((option) => option.value === props.values.type);

    const onChange = (option: unknown | null) => {
        const optionValue = (option as {value: PromotionType})?.value;
        typeSelectProps.onChange("type", optionValue);
    };

    return (
        <div className={filters}>
            <div className={cityFilter}>
                <PromotionListSearchFilter />
            </div>

            <div className={offerTypeFilter}>
                <Select isClearable value={currentTypeOption} options={promotionTypes} name="type" onChange={onChange} placeholder="Typ oferty" />
            </div>
        </div>
    );
};

export const PromotionListFilters = form(PromotionListFiltersC);

const filters = css({
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    width: "100%",

    sm: {
        flexDirection: "row"
    },

    md: {
        width: "auto"
    }
});

const cityFilter = css({
    width: "100%",
    mb: 2,

    sm: {
        width: "50%",
        mb: 0,
        me: 3
    },

    md: {
        width: "36rem"
    }
});

const offerTypeFilter = css({
    width: "100%",

    sm: {
        width: "50%"
    },

    md: {
        width: "22rem"
    }
});
import {css} from "@panda/css";

import {Select} from "@pg-design/select-module";
import {form, FormFieldType, IFormProps} from "@pg-mono/form";

import {PromotionType, promotionTypes} from "../../../helpers/PromotionType";
import {PromotionListSearchFilter} from "./PromotionListSearchFilter";

export const promotionListFilterFields = {
    type: FormFieldType.Select
};

export interface IPromotionListFilterFields {
    type: PromotionType;
}

interface IPromotionListFilters extends IFormProps<IPromotionListFilterFields> {}

const PromotionListFiltersC = (props: IPromotionListFilters) => {
    const typeSelectProps = props.getFieldProps("type");
    const currentTypeOption = promotionTypes.filter((option) => option.value === props.values.type);

    const onChange = (option: unknown | null) => {
        const optionValue = (option as {value: PromotionType})?.value;
        typeSelectProps.onChange("type", optionValue);
    };

    return (
        <div className={filters}>
            <div className={cityFilter}>
                <PromotionListSearchFilter />
            </div>

            <div className={offerTypeFilter}>
                <Select isClearable value={currentTypeOption} options={promotionTypes} name="type" onChange={onChange} placeholder="Typ oferty" />
            </div>
        </div>
    );
};

export const PromotionListFilters = form(PromotionListFiltersC);

const filters = css({
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    width: "100%",

    sm: {
        flexDirection: "row"
    },

    md: {
        width: "auto"
    }
});

const cityFilter = css({
    width: "100%",
    mb: 2,

    sm: {
        width: "50%",
        mb: 0,
        me: 3
    },

    md: {
        width: "36rem"
    }
});

const offerTypeFilter = css({
    width: "100%",

    sm: {
        width: "50%"
    },

    md: {
        width: "22rem"
    }
});
